var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _c("div", { staticClass: "headerbox" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title_left" }),
          _c("span", { staticClass: "top_title" }, [
            _vm._v(
              _vm._s(_vm.pageTitle == 1 ? "分群变更记录" : "标签变更记录")
            ),
          ]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.staffTableAchievement.loading,
                expression: "staffTableAchievement.loading",
              },
            ],
            staticClass: "content achievement",
          },
          [
            _vm._m(0),
            _c("common-table", {
              attrs: {
                dataList: _vm.page.list,
                config: _vm.staffTableAchievement.config,
                sortObj: _vm.staffTableAchievement.sortObj,
              },
            }),
            _c(
              "div",
              { staticClass: "page" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.page.pageNo,
                    "page-sizes": [3, 5, 10, 20, 50],
                    "page-size": _vm.page.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.page.totalNum,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "card-title" }, [
      _c("label", [_c("span", { staticClass: "title" }, [_vm._v("变更记录")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }